import { removeCookieSessionLogin, getAuthToken } from '~/utils/cookie'
import { isIgnoreAuthPath } from '~/utils/route'
import { BUSYBEES_SCHOOL } from '~/global/data/common'

const mutationTypes = {
  SET_APP_LOADING: 'SET_APP_LOADING',
}

export const state = () => ({
  appLoading: true,
})

export const mutations = {
  [mutationTypes.SET_APP_LOADING](state, appLoading) {
    state.appLoading = appLoading
  },
}

export const actions = {
  async nuxtServerInit({ dispatch, commit, state }, { redirect, app, route }) {
    const isIgnoreAuth = isIgnoreAuthPath(route.path)
    const { token: userToken, isExternal } = getAuthToken(app)

    if (userToken) {
      try {
        // Set the token for Apollo client if using external token
        if (isExternal) {
          await app.$apolloHelpers.onLogin(userToken, undefined)
        }

        await dispatch('profile/REFRESH_USER_TOKEN')
        await dispatch('profile/CHECK_AUTHENTICATION')
        await dispatch('school/FETCH_SCHOOL_TREE')
        await dispatch('profile/FETCH_USER_PROFILE')

        const currentSchoolProfile = state.school.schoolProfile
        await dispatch('organisation/FETCH_ORG_KEYWORDS', {
          organisationId: `${currentSchoolProfile?.parentId || currentSchoolProfile?.id}`,
        })
      } catch (error) {
        const isUnauthorized = error.message === 'GraphQL error: unauthorized'
        if (isUnauthorized) {
          redirect({ name: 'not-permission' })
        } else {
          redirect({
            name: 'signin',
            query: { ...route.query, from: route.path.includes('not-permission') ? '' : route.path },
          })
        }
        removeCookieSessionLogin(app)
      }
    } else if (!isIgnoreAuth) {
      removeCookieSessionLogin(app)
      redirect({ name: 'signin', query: { from: route.fullPath } })
    }
  },
}

export const getters = {
  appLoading: (state) => state.appLoading,
  featureFlags: (_, __, ___, rootGetters) => {
    return {
      academy: {
        enableHomeTab: !BUSYBEES_SCHOOL.includes(rootGetters['school/schoolId']),
      },
      performance: {
        appraisalV2: true,
      },
    }
  },
}
